module.exports = __webpack_public_path__ + "assets/img/fm01.1e79e622.jpg";